import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { Preview } from 'vue-advanced-cropper'
import { debounce } from '@/lib/lodash'

@Component({
  components: {
    Preview,
  },
})
export default class ThumbnailCropperPreview extends Vue {
  @Ref('preview') private readonly previewRef?: {
    refresh: () => void
  }
  @Prop({ type: Boolean, default: false }) private readonly active!: boolean
  @Prop({ type: String }) private readonly title?: string
  @Prop({ type: String }) private readonly subtitle?: string
  @Prop({ type: String }) private readonly description?: string
  @Prop({ type: Number }) private readonly aspectRatio?: number
  @Prop({ type: String, default: 'blue-grey lighten-4' })
  private readonly bgColor!: string
  @Prop({ type: Object })
  private readonly coordinates?: {
    left: number
    top: number
    width: number
    height: number
  }
  @Prop({ type: Object }) private readonly image?: {
    src: string
  }

  private localAspectRatio = 1

  private get showedPreview() {
    return !!this.coordinates && !!this.image
  }

  private get iconSize() {
    return this.$vuetify.breakpoint.xsOnly ? 16 : 20
  }

  private get iconColor() {
    if (this.active) {
      return 'primary'
    }

    if (this.showedPreview) {
      return 'green'
    }

    return 'blue-grey lighten-4'
  }

  private get titleColorClassName() {
    if (this.active) {
      return 'primary--text'
    }

    return 'blue-grey--text text--darken-3'
  }

  private onReplaceImage() {
    this.$emit('replace:image')
  }

  private onClickPreview() {
    this.$emit('click:preview')
  }

  private created() {
    this.localAspectRatio = this.aspectRatio ?? 1
  }

  private mounted() {
    const deounceRefreshPreview = debounce(() => {
      this.previewRef?.refresh()
    }, 250)

    const onChangeAspectRatio = debounce(() => {
      if (
        !this.aspectRatio &&
        this.coordinates?.width &&
        this.coordinates?.height
      ) {
        this.localAspectRatio = +(
          this.coordinates.width / this.coordinates.height
        ).toFixed(3)
      } else {
        this.localAspectRatio = this.aspectRatio ?? 1
      }

      deounceRefreshPreview()
    }, 100)

    this.$watch(
      () => {
        return [
          this.aspectRatio,
          this.coordinates?.width,
          this.coordinates?.height,
        ].join('-')
      },
      onChangeAspectRatio,
      {
        immediate: true,
      }
    )

    this.$once('hook:beforeDestroy', () => {
      onChangeAspectRatio.cancel()
      deounceRefreshPreview.cancel()
    })
  }
}
